<span class="result-status-badge" [class]="'result-status-badge--' + kind()">
  {{ labelKey() | translate }}
</span>
